// Configuración de usuarios bloqueados
export const BLOCKED_USERS_CONFIG = {
    blockedEmails: [
        'rgramajo@mineduc.gob.gt',
        'ricardo.asin@crehana.com',
        'lcal@mineduc.gob.gt',
        'odchalic@mineduc.gob.gt',
        'maanaviscab@mineduc.gob.gt',
        'jdramirez@mineduc.gob.gt',
        'lazepedar@mineduc.gob.gt',
        'halinado@mineduc.gob.gt',
        'apcastellanos@mineduc.gob.gt',
        'mnramirez@mineduc.gob.gt',
        'pcajas@mineduc.gob.gt',
        'mmuralles@mineduc.gob.gt',
        'AGPENATEM@MINEDUC.GOB.GT',
        'rplopez@mineduc.gob.gt',
        'jsican@mineduc.gob.gt',
        'rngomez@mineduc.gob.gt',
        'MCHACACH@MINEDUC.GOB.GT',
        'hmmerida@mineduc.gob.gt',
        'salvarezb@mineduc.gob.gt',
        'dbcocr@mineduc.gob.gt',
        'YMGARCIA@MINEDUC.GOB.GT',
        'Nparedes@mineduc.gob.gt',
        'lkhoenesr@mineduc.gob.gt',
        'jjacobo@mineduc.gob.gt',
        'lcastanon@mineduc.gob.gt',
        'halfaro@mineduc.gob.gt',
        'vsandova@mineduc.gob.gt',
        'aoliva@mineduc.gob.gt',
        'dperezm@mineduc.gob.gt',
        'gvrodriguez@mineduc.gob.gt',
        'SRUANO@MINEDUC.GOB.GT',
        'enortiza@mineduc.gob.gt',
        'agarciad@mineduc.gob.gt',
        'sruanol@mineduc.gob.gt',
        'mlcamposano@mineduc.gob.gt',
        'hajuarez@mineduc.gob.gt',
        'richel@mineduc.gob.gt',
        'neleiva@mineduc.gob.gt',
        'IHERRERA@MINEDUC.GOB.GT',
        'jcaceres@mineduc.gob.gt',
        'hfloresb@mineduc.gob.gt',
        'agcarreto@mineduc.gob.gt',
        'mjarevalog@mineduc.gob.gt',
        'AGARRIDO@MINUEDUC.GOB.GT',
        'fcalderon@mineduc.gob.gt',
        'gmcabrerac@mineduc.gob.gt',
        'lburgos@mineduc.gob.gt',
        'larreagas@mineduc.gob.gt',
        'jamezaa@mineduc.gob.gt',
        'hfpineda@mineduc.gob.gt',
        'ncontreras@mineduc.gob.gt',
        'ejescott@mineduc.gob.gt',
        'lpjcano@mineduc.gob.gt',
        'aesecaira@mineduc.gob.gt',
        'clima@mineduc.gob.gt',
        'ergonzalezr@mineduc.gob.gt',
        'maaguirreg@mineduc.gob.gt',
        'pgonzalez@mineduc.gob.gt',
        'aicholoticc@mineduc.gob.gt',
        'comunozo@mineduc.gob.gt',
        'lrivas@mineduc.gob.gt',
        'agarciag@mineduc.gob.gt',
        'Aeorizabalq@mineduc.gob.gt',
        'ehmartinezm@mineduc.gob.gt',
        'cmateo@mineduc.gob.gt',
        'msosa@mineduc.gob.gt',
        'scampos@mineduc.gob.gt',
        'khurtarte@mineduc.gob.gt',
        'aymonterrosoq@mineduc.gob.gt',
        'angelikatobar092@Gmail.com',
        'aflores@mineduc.gob.gt',
        'rmacario@mineduc.gob.gt',
        'wchamale@mineduc.gob.gt',
        'HTUNCHE@MINEDUC.GOB.GT',
        'NORIVERA@MINEDUC.GOB.GT',
        'mmejia0172@mineduc.gob.gt',
        'yrosales@mineduc.gob.gt',
        'Jdquintanillaa@mineduc.gob.gt',
        'sehernandez@mineduc.gob.gt',
        'HPONCE@MINEDUC.GOB.GT',
        'jberges@mineduc.gob.gt',
        'rrodasm@mineduc@gob.gt',
        'jbautista@mineduc.gob.gt',
        'Egmarin@mineduc.gob.gt',
        'halvarado@mineduc.gob.gt',
        'doherrerav@mineduc.gob.gt',
        'Msotol@mineduc.gob.gt',
        'malopeza@mineduc.gob.gt',
        'evperezj@mineduc.gob.gt',
        'cajolonp@mineduc.gob.gt',
        'Beherrarteb@mineduc.gob.gt',
        'cvillela@mineduc.gob.gt',
        'Mlmorales@mineduc.gob.gt',
        'iacoc@mineduc.gob.gt',
        'msian@mineduc.gob.gt',
        'jhortiz@mineduc.gob.gt',
        'Eabarriosb@mineduc.gob.gt',
        'LAMEJIA@MINEDUC.GOB.GT',
        'mhernandezr@mineduc.gob.gt',
        'epirir@mineduc.gob.gt',
        'Lerivasr@mineduc',
        'karengonzalez@mineduc.gob.gt',
        'oolivares@mineduc.gob.gt',
        'acalderon@mineduc.gob.gt',
        'myfloresc@mineduc.gob.gt',
        'lvgarciam@mineduc.gob.gt',
        'zmalonzoc@mineduc.gob.gt',
        'holivac@mineduc.gob.gt',
        'arosales@mineduc.gib.gt',
        'ejgutierrez@mineduc.gob.gt',
        'wgarciaa@mineduc.gob.gt',
        'JABRAN@MINEDUC.GOB.GT',
        'inramirezv@mineduc.gob.gt',
        'dreyes@mineduc.gob.gt',
        'fcastillo@mineduc.gob.gt',
        'mhuit@mineduc.gob.gt',
        'ycvelasquezh@mineduc.gob.gt',
        'opgonzalezc@mineduc.gob.gt',
        'alcastro@mineduc.gob.gt',
        'hlvalenzuela@mineduc.gob.gt',
        'mcpineda@mineduc.gob.gt',
        'Jnlopez@mineduc.gob.gt',
        'daguilar@mineduc.gob.gt',
        'lcrispin@mineduc.gob.gt',
        'rreynoso@mineduc.gob.gt',
        'cijuarezg@mineduc.gob.gt',
        'Kacruz@mineduc.gob.gt',
        'jltavicoc@mineduc.gob.gt',
        'hrsalazar@mineduc.gob.gt',
        'jmjuarez@mineduc.gob.gt',
        'Lamoranl@mineduc.gob.gt',
        'kschajon@mineduc.gob.gt',
        'amarroquinr@mineduc.gob.gt',
        'Esramosa@mineduc.gob.gt',
        'Lgvaldez@mineduc.gob.gt',
        'Aracancojr@mineduc.gob.gt',
        'dreyes@mineduc.gob.gt',
        'klmoraless@mineduc.gob.gt',
        'jsalgueros@mineduc.gob.gt',
        'mxitumul@mineduc.gob.gt',
        'ESRAMOSA@MINEDUC.GOB.GT',
        'jmordonez@mineduc.gob.gt',
        'gmosorioj@mineduc.gob.gt',
        'borozco@mineduc.gob.gt',
        'mrgarcia@mineduc.gob.gt',
        'Acabreras@mineduc.gob.gt',
        'mmgonzalezc@mineduc.gob.gt',
        'btobar@mineduc.gob.gt',
        'bvreyesl@mineduc.gob.gt',
        'acabreras@mineduc.gob.gt',
        'eezapet@mineduc.gob.gt',
        'lpeque@mineduc.gob.gt',
        'Bkhernandezc@mineduc.gob.gt',
        'ajgirong@mineduc.gob.gt',
        'aarodriguezm@mineduc.gob.gt',
        'jmolinai@mineduc.gob.gt',
        'nlopezp@mineduc.gob.gt',
        'wadeleon@mineduc.gob.gt',
        'nalvarez@mineduc.gob.gt',
        'dirodriguezr@mineduc.gob.gt',
        'lesamayoac@mineduc.gob.gt',
        'ALTGALINDO@MINEDUC.GOB.GT',
        'ssosa@mineduc.gob.gt',
        'lflorian@mineduc.gob.gt',
        'eeperez@mineduc.gob.gt',
        'lsolis@mineduc.gob.gt',
        'lvillagran@mineduc.gob.gt',
        'fbetancourths@mineduc.gob.gt',
        'mscalderonl@mineduc.gob.gt',
        'catherine.finobarrientosdepaz@mineduc.edu.gt',
        'prsalazarp@mineduc.gob.gt',
        'sroldan@mineduc.gob.gt',
        'MAMOLINA@MINEDUC.GOB.GT',
        'muluan@mineduc.gob.gt',
        'elsantoss@mineduc.gob.gt',
        'lmpereza@mineduc.gob.gt',
        'atijer@mineduc.gob.gt',
        'asosa@mineduc.gob.gt',
        'eramirezr@mineduc.gob.gt',
        'ysolares@mineduc.gob.gt',
        'asical@mineduc.gob.gt',
        'momendez@mineduc.gob.gt',
        'omorales@mineduc.gob.gt',
        'talvarado@mineduc.gob.gt',
        'rcguerra@mineduc.gob.gt',
        'bgaguilar@mineduc.gob.gt',
        'rjacobo@mineduc.gob.gt',
        'iorellana@mineduc.gob.gt',
        'rhernandez@mineduc.gob.gt',
        'BSOLIS@MINEDUC.GOB.GT',
        'sramos@mineduc.gob.gt',
        'majins@mineduc.gob.gt',
        'sgiron@mineduc.gob.gt'
    ],

    blockedDomain: '', //'mineduc.com',

    blockedCompanyIds: [
       //62  //Ministerio de Educación (MINEDUC)
    ],

    blockedMessage: 'Su cuenta no tiene acceso a este contenido. Sólo puedes acceder a este contenido si estas fuera de horario de oficina.',
    blockedButtonText: 'Acceso restringido'
}

export const isEmailBlocked = (email) => {
    return BLOCKED_USERS_CONFIG.blockedEmails.includes(email)
}

export const matchesBlockedDomain = (email) => {
    const domainPattern = new RegExp(`^[a-zA-Z0-9._-]+@${BLOCKED_USERS_CONFIG.blockedDomain.replace('.', '\\.')}$`)
    return domainPattern.test(email)
}

export const isCompanyBlocked = (companyId) => {
    if (!companyId) return false
    return BLOCKED_USERS_CONFIG.blockedCompanyIds.includes(companyId)
}

// Función para verificar si estamos en horario de oficina (lunes a viernes, 6am-6pm Guatemala)
export const isBusinessHours = () => {
    const now = new Date()
    const guatemalaTime = new Date(now.toLocaleString("en-US", { timeZone: "America/Guatemala" }))
    const dayOfWeek = guatemalaTime.getDay()
    const hour = guatemalaTime.getHours()

    const isWeekday = dayOfWeek >= 1 && dayOfWeek <= 5
    const isWorkingHour = hour >= 6 && hour < 18 


    return !(isWeekday && isWorkingHour) //Se habilita desde las 6am hasta las 6pm
}

// Función principal para verificar si el usuario debe ser bloqueado
export const shouldBlockUser = (email, companyId = null) => {
    if (!email) return false

    const isEmailOrDomainBlocked = isEmailBlocked(email) || matchesBlockedDomain(email)

    const isUserCompanyBlocked = isCompanyBlocked(companyId)

    if (isEmailOrDomainBlocked || isUserCompanyBlocked) {
        return isBusinessHours()
    }

    return false
} 